export const CREATE_PREFORMA_INVOICE = `mutation (
  $bookingId: String!
  $invoiceNumber: String!
  $invoiceDate: String!
  $billingEntity: create_preforma_invoice_billing_entity!
  $lineItems: [create_preforma_invoice_line_items]!
  $grandTotal: Float!
  $gstEnabled: Boolean!
) {
  create_preforma_invoice(
    booking_id: $bookingId
    invoice_number: $invoiceNumber
    invoice_date: $invoiceDate
    billing_entity: $billingEntity
    line_items: $lineItems
    grand_total: $grandTotal
    gst_enabled: $gstEnabled
  ) {
    message
    data {
      _id
      booking_id
      invoice_number
      invoice_date
      billing_entity {
        name
        address
        email
        mobile
        gstin
      }
      line_items {
        id
        description
        qty
        inclusive_rate
        inclusive_amount
        base
        sgst
        cgst
        tax_rate
      }
      grand_total
      gst_enabled
      status
      createdAt
      updatedAt
    }
  }
}`;

export const GET_PREFORMA_INVOICE = `query ($bookingId: String!) {
  get_preforma_invoice(booking_id: $bookingId) {
    message
    data {
      _id
      booking_id
      invoice_number
      invoice_date
      billing_entity {
        name
        address
        email
        mobile
        gstin
      }
      line_items {
        id
        description
        qty
        inclusive_rate
        inclusive_amount
        base
        sgst
        cgst
        tax_rate
      }
      grand_total
      gst_enabled
      status
      createdAt
      updatedAt
    }
  }
}`;

export const UPDATE_PREFORMA_INVOICE = `mutation (
  $bookingId: String!
  $invoiceNumber: String!
  $invoiceDate: String!
  $billingEntity: update_preforma_invoice_billing_entity!
  $lineItems: [update_preforma_invoice_line_items]!
  $grandTotal: Float!
  $gstEnabled: Boolean!
) {
  update_preforma_invoice(
    booking_id: $bookingId
    invoice_number: $invoiceNumber
    invoice_date: $invoiceDate
    billing_entity: $billingEntity
    line_items: $lineItems
    grand_total: $grandTotal
    gst_enabled: $gstEnabled
  ) {
    message
    data {
      _id
      booking_id
      invoice_number
      invoice_date
      billing_entity {
        name
        address
        email
        mobile
        gstin
      }
      line_items {
        id
        description
        qty
        inclusive_rate
        inclusive_amount
        base
        sgst
        cgst
        tax_rate
      }
      grand_total
      gst_enabled
      status
      updatedAt
    }
  }
}`;